













import { Vue, Component } from 'vue-property-decorator'
import { Container, Logo, Box, PositiveSubheader, Button } from '../atoms/'
import { APP_MODULE, IS_PARTER, TRANSLATE } from '../../store/modules/app/constant'
import { mapGetters } from 'vuex'
import { AUTH_MODULE, FORGOT_EMAIL_LOGIN } from '@/store/modules/auth/constant'

@Component({
  components: {
    Container,
    Logo,
    Box,
    PositiveSubheader,
    Button
  },
  computed: {
    ...mapGetters(APP_MODULE, [IS_PARTER, TRANSLATE]),
    ...mapGetters(AUTH_MODULE, [FORGOT_EMAIL_LOGIN])
  }
})
export default class ForgotPasswordSent extends Vue {
  private email = ''
  mounted() {
    this.email = this.forgotEmail
  }
  get forgotEmail(): string {
    return (this as any)[FORGOT_EMAIL_LOGIN]
  }

  get channel() {
    return this.$route?.query?.channel
  }

  backToLogin() {
    const baseURL = process.env.VUE_APP_FINNO_ENDPOINT || ''
    location.href = baseURL
  }
}
